
<template scope="scope">
    <el-dialog title="您正在操作商品信息审核！" :visible.sync="dialogAuthStatusFormVisible"  width="30%" >
            <el-form style="margin-left:20px;" ref="dialogAuthStatusForm" :model="dialogAuthStatusForm" label-width="160px">
                <el-radio-group v-model="dialogAuthStatusForm.authStatus" >
                   <el-radio  :label="2">审核通过</el-radio>
                   <div style="height:20px;"></div>
                   <el-radio   :label="3">审核不通过</el-radio>
               </el-radio-group>

                 <el-input type="textarea" style="margin-left:30px;width:80%"  :rows="2"
                  v-model="dialogAuthStatusForm.remark" placeholder="请输入操作理由"  @input="isSendInfo()"></el-input>

               <div  style="margin-left:30px;width:80%" >
                 <el-checkbox v-model="dialogAuthStatusForm.isSend"  @change="isSendInfo()" style="">发送短信</el-checkbox> <span style="color:red;">{{dialogAuthStatusForm.sendInfo}}</span>
               </div>
            </el-form>
            <div slot="footer" class="dialog-footer">

                <el-button type="primary" @click="authStatus()" v-loading.fullscreen.lock="fullscreenLoading">确认无误</el-button>
            </div>
    </el-dialog>

</template>

<script>
import Config from '@/framework/configs/Config'
import BasicPager from '@/mixins/BasicPager'
import JoinGoodsCarShowDialog from '@/pages/plusbusiness/children/JoinGoodsCarShowDialog'
import usedCarModel from '@/framework/models/usedCarModel'

export default {
  name: 'auth-goods-status',
  data () {
    return {
      dialogAuthStatusFormVisible: false,
      fullscreenLoading: false,
      dialogAuthStatusForm: {
        id: null,
        authStatus: 2,
        isSend: true,
        sendInfo: '',
        remark: null
      }
    }
  },
  methods: {
    isSendInfo: function () {
      if (this.dialogAuthStatusForm.isSend && this.dialogAuthStatusForm.authStatus == 3 && this.dialogAuthStatusForm.remark) {
        this.dialogAuthStatusForm.sendInfo = '很抱歉，您发布的商品未通过：' + this.dialogAuthStatusForm.remark
      } else {
        this.dialogAuthStatusForm.sendInfo = ''
      }
    },
    showAuthStatus: function (id) {
      this.dialogAuthStatusFormVisible = true
      this.dialogAuthStatusForm.id = id
      this.dialogAuthStatusForm.remark = null
      this.dialogAuthStatusForm.sendInfo = null
      this.dialogAuthStatusForm.isSend = true
    },

    authStatus: function () {
      let _this = this
      let param = { 'id': this.dialogAuthStatusForm.id, 'authStatus': this.dialogAuthStatusForm.authStatus }
      if (this.dialogAuthStatusForm.authStatus === 3 && this.dialogAuthStatusForm.isSend) {
        if (!this.dialogAuthStatusForm.remark) {
          _this.$message({
            message: '不通过理由不能为空！',
            type: 'error'
          })
          return
        }
        param.sendInfo = this.dialogAuthStatusForm.remark
      } else {
        param.sendInfo = null
      }
      this.fullscreenLoading = true
      let listener = {
        success: function (dataInfo) {
          _this.fullscreenLoading = false
          _this.dialogAuthStatusFormVisible = false
          setTimeout(() => {
            _this.$message({
              message: '审核成功',
              type: 'success'
            })
          }, 1000)
          _this.$emit('onSuccess')
        },
        error: function (dataInfo) {
          _this.fullscreenLoading = false
          _this.dialogAuthStatusFormVisible = false
          setTimeout(() => {
            _this.$message({
              message: '处理失败',
              type: 'error'
            })
          }, 1000)

          _this.$emit('onSuccess')
        }
      }
      usedCarModel.changeGoodsAuthStatus(_this, param, listener)
    },
    hideDialog () {
      this.dialogAuthFormVisible = false
    }
  }
}

</script>
